import React from 'react'
import { SVGIconProps } from '../types'
const SvgArrowRight = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="m10 17 5-5-5-5z" />
    <path fill="none" d="M0 24V0h24v24z" />
  </svg>
)
export default SvgArrowRight
